import { FC } from "react";
import { GBP_SYMBOL } from "lib/constants";
import FlexBox from "../flex-box";
import SimpleCard from "../simple-card";
import { formatDate, toFormattedDate } from "lib/utils/date-utils";

interface PatientBookingSummaryTileProps {
  practitionerName: string;
  clinicName: string;
  therapyName: string;
  duration: number;
  totalCost: string;
  invoiceURL?: string;
  checkoutSessionStatus?: string;
  fromTime: string;
}

const PatientBookingSummaryTile: FC<PatientBookingSummaryTileProps> = ({
  practitionerName,
  clinicName,
  therapyName,
  duration,
  totalCost,
  invoiceURL,
  checkoutSessionStatus,
  fromTime,
}) => {
  return (
    <SimpleCard className="rounded">
      <FlexBox justifyContent="center" alignItems="start" direction="column">
        <FlexBox justifyContent="between" alignItems="center">
          <small>Practitioner:</small>
          <small>
            <strong>{practitionerName}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Clinic:</small>
          <small>
            <strong>{clinicName}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Therapy:</small>
          <small>
            <strong>{therapyName}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Date:</small>
          <small>
            <strong>{formatDate(fromTime)}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>From:</small>
          <small>
            <strong>{toFormattedDate(new Date(fromTime), "hh:mm a")}</strong>
          </small>
        </FlexBox>
        <FlexBox justifyContent="between" alignItems="center">
          <small>Duration:</small>
          <small>
            <strong>{duration} mins</strong>
          </small>
        </FlexBox>
        {checkoutSessionStatus && (
          <FlexBox justifyContent="between" alignItems="center">
            <small>Payment Status:</small>
            <small>
              <strong>{checkoutSessionStatus}</strong>
            </small>
          </FlexBox>
        )}
        {invoiceURL && (
          <FlexBox justifyContent="between" alignItems="center">
            <small>Invoice:</small>
            <small>
              <a
                href={invoiceURL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                View Invoice
              </a>
            </small>
          </FlexBox>
        )}

        <hr />
        <FlexBox justifyContent="between" alignItems="center">
          <small>
            <b>Total Cost: </b>
          </small>
          <small>
            <strong>
              {GBP_SYMBOL}&nbsp;
              {totalCost}
            </strong>
          </small>
        </FlexBox>
      </FlexBox>
    </SimpleCard>
  );
};

export default PatientBookingSummaryTile;
